import GlideInitializer from "./Modules/GlideInit";

new GlideInitializer();
